<template>
	<div class="services-industrial-internet-list">
		<div class="services-industrial-internet-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Web Services - Industrial Internet of Things  Solution</span>
			</div>

			<div class="list">
				<div class="tt">
					<img :src="solution_image_01" alt="Xhorse"/>
					<img :src="solution_image_02" alt="Xhorse"/>
				</div>
				<div class="dd">
					<ul>
						<li>
							<h3>Control device data at will:</h3>
							<p>
								Data transmission and application are no longer limited to limited application scenarios or factory space. Any PC and mobile app can assist enterprises to realize remote management, control and operation.</p>
						</li>
						<li>
							<h3>Stable and reliable Data:</h3>
							<p>
								The intelligent sensing elements, such as sensors, vision, Reid and wireless sensor network, are used to collect production data at any time and anywhere.</p>
						</li>
						<li>
							<h3>Information Security:</h3>
							<p>
								We take use of  a variety of communication network interconnection means, such as industrial gateway, short-distance wireless communication, low-power Wan, etc., to collect and transmit data accurately in real-time.We take use of  a variety of communication network interconnection means, such as industrial gateway, short-distance wireless communication, low-power Wan, etc., to collect and transmit data accurately in real-time.</p>
						</li>
						<li>
							<h3>Big data application, mining deep value:</h3>
							<p>
								Based on Amazon cloud platform, through cloud computing, big data and other related technologies, the production data is modeled, analyzed and optimized to realize the deep development and application of multi-source heterogeneous data. Hidden predictive information is extracted from the data warehouse, the potential relationship between data is mined out, and valuable information is quickly and accurately found out, providing data support for intelligent decision-making in production.</p>
						</li>
					</ul>

				</div>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_web_01.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_web_02.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02
            };
        }
    }

</script>

<style scoped="">
	.dd > ul > li > h3 {
		font-family: "Open SB";
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.75rem;
	}

	.dd > ul > li > p {
		width: 100%;
		font-size: 1rem;
		color: #212525;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.75rem;
	}

	.dd > ul > li {
		width: 100%;
		margin-bottom: 1.5rem;
	}

	.dd > ul {
		width: 100%;
		height: 35rem;
		margin-top: 2.75rem;
	}

	.dd {
		margin-top: 2.75rem;
	}

	.tt > img:last-child {
		width: calc(100% - 29.75rem - 1.5rem);
		margin-left: 1.5rem;
	}

	.tt > img:first-child {
		width: 29.75rem;
	}

	.tt > img {
		float: left;
		height: 20rem;
	}

	.tt {
		width: 100%;
		height: 20rem;
		border: none;
	}

	.list > .tt, .list > .dd {
		width: 100%;
	}

	.services-industrial-internet-con {
		width: 61.5rem;
		border: none;
		margin-left: 0;
	}

	.services-industrial-internet-list {
		width: 61.5rem;
		height: 65.5rem;
		border: none;
	}

	.list {
		width: 54.5rem;
		border: none;
		margin-left: 7rem;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-developing-modules.vue